export default __webpack_public_path__ + "static/media/mic.db4e18ba.svg";